import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import { RaisedButton } from 'material-ui';
import { FleetActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';

class TrackerItem extends Component {
  constructor(props) {
    super(props);

    this.assignTracker = this.assignTracker.bind(this);
  }
  componentWillMount() {
    const { fleet, params } = this.props;
    if (!fleet || !fleet.tracker) {
      this.props.dispatch(FleetActions.getTracker(params.id));
    }
  }

  gotoTrackers = () => {
    browserHistory.push('/fleet/trackers');
  }

  assignTracker() {
    const { params } = this.props;
    browserHistory.push(`/fleet/tracker/${params.id}/assign`);
  }

  render() {
    const { fleet } = this.props;
    let title = 'Tracker';
    let content;

    if (!fleet || !fleet.tracker) {
      content = <Loader />;
    } else {
      title = `Tracker ${fleet.tracker.coreid}`;
      content = (
        <div className="row">
          <div className="col s12 center-align">
            <img src={`https://maps.googleapis.com/maps/api/staticmap?&zoom=14&size=600x300&maptype=roadmap
&markers=color:green%7C%7C${fleet.tracker.gps.lat},${fleet.tracker.gps.lon}&key=AIzaSyBpypOsvkOpxFW26XXu75CNOxAPrgM3U8w`} alt="map-view" />
          </div>
          <div className="col s12">Battery: {fleet.tracker.battery}%</div>
          <div className="col s12">Trailer is: {(fleet.tracker.full === "0") ? 'Empty' : 'Full'}</div>
          <div className="col s12">Last Update: {moment(fleet.tracker.published_at).format('lll')}</div>
          {fleet.tracker.type && fleet.tracker.typeId &&
            <div className="col s12">Assigned To: {fleet.tracker.type} {fleet.tracker.typeId}</div>
          }
          {!fleet.tracker.type && !fleet.tracker.typeId &&
            <div className="col s12"><RaisedButton label="Assign Device" primary={true} onClick={this.assignTracker} /></div>
          }
        </div>);
    }

    const subnavItems = []
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} back={this.gotoTrackers} />
          <TitleBar title={title} />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { fleet } = state;
  return {
    fleet
  }
}

export default connect(mapStateToProps)(TrackerItem);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Trackers/Item.js